import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          minWidth: '100px',
          height: 'auto',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '0.5rem',
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '0.5rem',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.42)',
          },
          height: 'auto',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: '#fcf4e9',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#fcf4e9',
          },
          '&&.Mui-selected': {
            backgroundColor: '#fcf4e9',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#765454',
          '&.Mui-focused': {
            color: '#765454',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          maxHeight: '300px',
        },
      },
    },
  },
})

export default theme
